// module is considered a microapp e.g. booking, lookbook. So in case we will need to merge two microapps into one, this setup will allow us to do it with less effort.
// if you have more than one module here, please specify the name and path in the list below
// This list is also used for the link component to check if it is an internal or external link
export const modulesInApp = {};

export const availableModules = Object.keys(modulesInApp);

// if only one module in this app, moduleName is optional
export const getBaseUrl = (moduleName = 'app') => {
  // if moduleName provided, default to first one if not
  return moduleName && modulesInApp[moduleName]
    ? modulesInApp[moduleName].baseURL
    : '/';
};

export function getConfigValue(key: string, defaultValue?: string): string {
  const config = {
    ENV: 'local',
    API_URL: '',
    STRIPE_APIKEY: 'pk_test_uiIFMYEqNaebW7Br39Iwbdqk',
  };

  if (key in config) {
    return config[key];
  }

  if (!defaultValue) {
    // eslint-disable-next-line
    console.error(`Configuration Error: required environment variable '${key}' not found.`);
  }

  return defaultValue || '';
}

export default {
  get exportKeys() {
    return ['API_URL', 'BASE_PATH', 'LOCAL_JWT', 'ENV', 'STRIPE_APIKEY'];
  },

  get appEnv() {
    return getConfigValue('ENV');
  },

  get basePath() {
    return getConfigValue('BASE_PATH');
  },

  get port() {
    return getConfigValue('PORT');
  },

  get host() {
    return `localhost:${getConfigValue('PORT')}`;
  },

  get apiEndpoint() {
    const appUrl = getConfigValue('API_URL');

    return appUrl;
  },

  get stripeApikey() {
    const isClientSide = typeof window !== 'undefined' && window.document && typeof window.document.createElement === 'function';
    if (isClientSide) {
      const { hostname } = window.location;
      const isLiveMode = hostname.indexOf('fave.style') > -1 || hostname.indexOf('favesalon.com') > -1;

      if (isLiveMode) {
        return 'pk_live_MSJJldE3AnsUgwMrG2EJCjq0';
      }
    }

    return getConfigValue('STRIPE_APIKEY');
  },

  get isClientSide() {
    return typeof window !== 'undefined' && window.document && typeof window.document.createElement === 'function';
  },
};
